import { ElementType, ReactNode } from 'react';

import Message from 'types/Message';
import { Classes } from 'types/Classes';
import RenderInView from '@templates/RenderInView';
import Section from '@components/Section';

type Props = {
  title: Message;
  classes?: Classes<'root' | 'header' | 'title'>;
  headerComponent?: ElementType;
  forceShow?: boolean;
  children: ReactNode;
};

const RenderInViewSection = ({ title, classes, headerComponent, forceShow, children }: Props) => (
  <RenderInView>
    {({ inView, ref }) => (
      <Section ref={ref} title={title} classes={classes} headerComponent={headerComponent}>
        {(inView || forceShow) && children}
      </Section>
    )}
  </RenderInView>
);

export default RenderInViewSection;
